import { render, staticRenderFns } from "./bindMobile.vue?vue&type=template&id=ee9fdae6&scoped=true&"
import script from "./bindMobile.vue?vue&type=script&lang=js&"
export * from "./bindMobile.vue?vue&type=script&lang=js&"
import style0 from "./bindMobile.vue?vue&type=style&index=0&id=ee9fdae6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee9fdae6",
  null
  
)

component.options.__file = "bindMobile.vue"
export default component.exports